import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinDiagnosisIntro = lazyWithPreload(
  () => import('./SkinDiagnosisIntro'),
)
